var _defs, _g, _g2, _path, _path2, _path3, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a1a561;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.96,3h4.05c.55,0,1-.45,1-1h0c0-.55-.45-1-1-1H3.9c-1.6,0-2.9,1.3-2.9,2.9v4.1c0,.55,.45,1,1,1h0c.55,0,1-.45,1-1V3.96c0-.53,.43-.95,.95-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.04,3h-4.05c-.55,0-1-.45-1-1h0c0-.55,.45-1,1-1h4.1c1.6,0,2.9,1.3,2.9,2.9v4.1c0,.55-.45,1-1,1h0c-.55,0-1-.45-1-1V3.96c0-.53-.43-.95-.95-.95Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.96,21h4.05c.55,0,1,.45,1,1h0c0,.55-.45,1-1,1H3.9c-1.6,0-2.9-1.3-2.9-2.9v-4.1c0-.55,.45-1,1-1h0c.55,0,1,.45,1,1v4.05c0,.53,.43,.95,.95,.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.04,21h-4.05c-.55,0-1,.45-1,1h0c0,.55,.45,1,1,1h4.1c1.6,0,2.9-1.3,2.9-2.9v-4.1c0-.55-.45-1-1-1h0c-.55,0-1,.45-1,1v4.05c0,.53-.43,.95-.95,.95Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.12,5H5.87c-.48,0-.87,.39-.87,.87v4.24c0,.48,.39,.87,.87,.87h4.24c.48,0,.87-.39,.87-.87V5.87c0-.48-.39-.87-.87-.87Zm-1.13,4h-2v-2h2v2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.99,18.13v-4.24c0-.48-.39-.87-.87-.87H5.87c-.48,0-.87,.39-.87,.87v4.24c0,.48,.39,.87,.87,.87h4.24c.48,0,.87-.39,.87-.87Zm-2-1.13h-2v-2h2v2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.01,5.87v4.24c0,.48,.39,.87,.87,.87h4.24c.48,0,.87-.39,.87-.87V5.87c0-.48-.39-.87-.87-.87h-4.24c-.48,0-.87,.39-.87,.87Zm2,1.13h2v2h-2v-2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.01,
    y: 12.97,
    width: 2,
    height: 3.02,
    rx: 0.91,
    ry: 0.91
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.01,
    y: 12.97,
    width: 2.99,
    height: 2.02,
    rx: 0.92,
    ry: 0.92
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.97,
    y: 16.98,
    width: 5.03,
    height: 2.02,
    rx: 0.92,
    ry: 0.92
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.7217c0eec07f2bcab0b6bdb306b0e540.svg";
export { ForwardRef as ReactComponent };